export function Formatter(value) {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    // return 'R$ ' + value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
}

export function removeCurrencyFormat(value) {
    let result = value.replace(/[^0-9.]/g, '')
    return parseFloat(result)
}